<button
  class="new-action-btn"
  [attr.data-testid]="testIdValue()"
  mat-raised-button
  (click)="handleClick()"
  [style.id]="selector()"
  [disabled]="inProgress || isDisabled()"
  [class.disabled]="inProgress || isDisabled()"
  [class.hover-underline]="hoverUnderline()"
  [class.flex-start]="flexStart()"
  [style.height.px]="iconOnlySize() ? iconOnlySize()! + 6 : height()"
  [style.min-height.px]="iconOnlySize() ? iconOnlySize() : height()"
  [style.width.px]="iconOnlySize() || width()"
  [style.min-width.px]="iconOnlySize() || width()"
  [style.padding-bottom.px]="paddingBottom()"
  tabindex="-1"
  [class.primary-button]="!themedButton() || themedButton() === 'primary'"
  [class.secondary-button]="themedButton() === 'secondary'"
  [class.tertiary-button]="themedButton() === 'tertiary'"
  [class.warn-tertiary-button]="themedButton() === 'warn-tertiary'"
  [class.clear-button]="themedButton() === 'clear'"
  [class.clear-primary-button]="themedButton() === 'clear-primary'"
  [class.clear-black-button]="themedButton() === 'clear-black'"
  [class.clear-gray-button]="themedButton() === 'clear-gray'"
  [class.clear-dark-gray-button]="themedButton() === 'clear-dark-gray'"
  [class.clear-danger-button]="themedButton() === 'clear-danger'"
  [class.danger-button]="themedButton() === 'danger'"
  [class.danger-secondary-button]="themedButton() === 'danger-secondary'"
  [class.link-button]="themedButton() === 'link'"
  [class.spinner]="inProgress && showLoader()"
  [class.w-full]="fullWidth()"
  [matTooltip]="tooltipText()"
>
  <div
    class="new-action-btn-content"
    [style.height.px]="iconOnlySize() ? iconOnlySize() : height()"
    [style.min-height.px]="iconOnlySize() ? iconOnlySize() : height()"
    [style.width.px]="iconOnlySize() || width()"
    [style.min-width.px]="iconOnlySize() || width()"
  >
    @if (icon()) {
      <lucide-icon
        [strokeWidth]="strokeWidth()"
        [size]="iconOnlySize() || iconSize() || 20"
        [img]="icon()!"
      ></lucide-icon>
    }
    <div
      class="text"
      [style.height.px]="height()"
      [style.min-height.px]="height()"
      [style.font-size.px]="fontSize()"
      [style.font-weight]="fontWeight()"
    >
      {{ text() }}
    </div>
  </div>
</button>
